import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { HttpService } from '@sondermind/http';
import { IAPIFetchRequestOptions, IAPIFetchResponse } from '@sondermind/utilities/models-http';
import { ConfigurationService } from '@sondermind/configuration';

import {
  convertApiResponse,
  IAppointmentSlot,
  IProviderCalendarApiResponse
} from '../models/public-provider-calendar.interface';

@Injectable({
  providedIn: 'root'
})
export class ProviderCalendarHttpService {
  constructor(
    private http: HttpService,
    private configService: ConfigurationService
  ){}

  getAppointmentSlots$(
    providerPersonaId: number,
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<IAppointmentSlot[] | null> {
    const url = this.getAppointmentSlotsUrl(providerPersonaId);
    const params = this.http.generateFetchParams(opts);

    return this.http.get<IProviderCalendarApiResponse>(url, params)
      .pipe(
        map((calendarResponse: IProviderCalendarApiResponse) => calendarResponse?.slots?.map(convertApiResponse) ?? []),
        this.http.handleHttpError()
      );
  }

  private getAppointmentSlotsUrl(providerPersonaId: number): string {
    return `${this.configService.env.dataExchangeSvcBase}/public/v1/slots?persona_provider_id=${providerPersonaId}`;
  }

  /** To-do: get this date from the earliest available slot when the calendar is implemented */
  /* eslint-disable @typescript-eslint/naming-convention */
  getSoonestAvailableDates$(
    providerPersonaIds: number[],
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<[{
      persona_provider_id: number;
      soonest_availability: Date | null;
    }]>{
    const apiUrl = `${this.configService.env.svcBase}/scheduling/soonest_available_sessions`;
    let params = this.http.generateFetchParams(opts);

    providerPersonaIds.forEach((id) => {
      params = params.append('persona_provider_ids[]', id.toString());
    });

    return this.http
      .get<IAPIFetchResponse<[{
      persona_provider_id: number;
      soonest_availability: Date | null;
    }]>>(apiUrl, params)
      .pipe(
        map((resp) => resp.data),
        this.http.handleHttpErrorStrict()
      );
  }
}
